import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import api, { getErr } from "../../lib/api";
import { NeonButton, NeonCard, Spinner } from "../../components/Neon";
import { gbp, fmtDateTime } from "../../lib/format";

export default function AdminExpenses() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [f, setF] = useState({ category: "", amount: "", description: "", vat: "" });
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/admin/expenses").then(({ data }) => setList(data || [])).catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!f.category || !f.amount) { toast.error("Category and amount required."); return; }
    setSaving(true);
    try { await api.post("/admin/expenses", { category: f.category, amount: Number(f.amount), description: f.description, vat: Number(f.vat) || 0 }); toast.success("Expense added."); setF({ category: "", amount: "", description: "", vat: "" }); load(); }
    catch (e) { toast.error(getErr(e)); } finally { setSaving(false); }
  };

  if (loading) return <Spinner />;
  const total = list.reduce((a, b) => a + (b.amount || 0), 0);

  return (
    <div data-testid="admin-expenses">
      <h2 className="font-display uppercase text-2xl text-white">Expenses</h2>
      <NeonCard variant="flow" className="mt-4" innerClassName="p-5">
        <div className="grid sm:grid-cols-4 gap-3">
          <input placeholder="Category" value={f.category} onChange={(e) => setF((s) => ({ ...s, category: e.target.value }))} className="bg-[var(--surface-2)] border border-white/10 rounded-lg px-3 py-2 text-white text-sm" data-testid="expense-category" />
          <input placeholder="Amount" type="number" value={f.amount} onChange={(e) => setF((s) => ({ ...s, amount: e.target.value }))} className="bg-[var(--surface-2)] border border-white/10 rounded-lg px-3 py-2 text-white text-sm" data-testid="expense-amount" />
          <input placeholder="VAT" type="number" value={f.vat} onChange={(e) => setF((s) => ({ ...s, vat: e.target.value }))} className="bg-[var(--surface-2)] border border-white/10 rounded-lg px-3 py-2 text-white text-sm" />
          <input placeholder="Description" value={f.description} onChange={(e) => setF((s) => ({ ...s, description: e.target.value }))} className="bg-[var(--surface-2)] border border-white/10 rounded-lg px-3 py-2 text-white text-sm" />
        </div>
        <NeonButton variant="pink" className="mt-3" onClick={add} loading={saving} data-testid="add-expense-button"><Plus className="h-4 w-4" /> Add Expense</NeonButton>
      </NeonCard>

      <NeonCard variant="soft" className="mt-4" innerClassName="p-0">
        <div className="overflow-x-auto"><table className="w-full text-sm">
          <thead><tr className="text-left text-[var(--text-muted)] border-b border-white/10"><th className="p-3">Category</th><th>Description</th><th>VAT</th><th>Date</th><th className="text-right p-3">Amount</th></tr></thead>
          <tbody>
            {list.map((e) => (<tr key={e.id} className="border-b border-white/5"><td className="p-3 text-white">{e.category}</td><td className="text-[var(--text-muted)]">{e.description}</td><td>{gbp(e.vat)}</td><td className="text-[var(--text-muted)]">{fmtDateTime(e.created_at)}</td><td className="text-right p-3 glow-pink">{gbp(e.amount)}</td></tr>))}
          </tbody>
          <tfoot><tr><td colSpan={4} className="p-3 text-right text-[var(--text-muted)]">Total</td><td className="text-right p-3 font-display text-lg glow-pink">{gbp(total)}</td></tr></tfoot>
        </table></div>
      </NeonCard>
    </div>
  );
}
